import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InactiveUsersCountQueryVariables = Types.Exact<{
  input: Types.GetPeopleInput;
}>;


export type InactiveUsersCountQuery = { __typename?: 'Query', People: { __typename?: 'Employees', totalCount: number } };


export const InactiveUsersCountDocument = gql`
    query InactiveUsersCount($input: GetPeopleInput!) {
  People(input: $input) {
    totalCount
  }
}
    `;

/**
 * __useInactiveUsersCountQuery__
 *
 * To run a query within a React component, call `useInactiveUsersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInactiveUsersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInactiveUsersCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInactiveUsersCountQuery(baseOptions: Apollo.QueryHookOptions<InactiveUsersCountQuery, InactiveUsersCountQueryVariables> & ({ variables: InactiveUsersCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InactiveUsersCountQuery, InactiveUsersCountQueryVariables>(InactiveUsersCountDocument, options);
      }
export function useInactiveUsersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InactiveUsersCountQuery, InactiveUsersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InactiveUsersCountQuery, InactiveUsersCountQueryVariables>(InactiveUsersCountDocument, options);
        }
export type InactiveUsersCountQueryHookResult = ReturnType<typeof useInactiveUsersCountQuery>;
export type InactiveUsersCountLazyQueryHookResult = ReturnType<typeof useInactiveUsersCountLazyQuery>;
export type InactiveUsersCountQueryResult = Apollo.QueryResult<InactiveUsersCountQuery, InactiveUsersCountQueryVariables>;